export const PagerLink: React.FC<{
  isCurrent?: boolean;
  href: string;
  children: any;
}> = ({ isCurrent, href, children }) => (
  <a
    href={href}
    className={`flex h-10 w-10 items-center justify-center rounded-md border border-secondary2 font-bold leading-none transition duration-500 ease-in-out hover:bg-secondary2 hover:text-white ${
      isCurrent ? 'cursor-default bg-secondary2 text-white' : ''
    }`}
  >
    {children}
  </a>
);
